import {createSlice} from "@reduxjs/toolkit";

const bulkTextureUpload = createSlice({
    name: 'bulkTextureUpload',
    initialState: {
        show: false,
        processing: false, 
        expand: true,
        hasData: false,
    },
    reducers: {
        openModal: (state) => {
            state.show = true;
        },
        closeModal: (state) => {
            state.show = false;
        },
        setProcessing: (state, { payload }) => {
            state.processing = payload;
        },
        setExpand: (state, { payload }) => {
            state.expand = payload;
        },
        setHasData: (state, { payload }) => {
            state.hasData = payload;
        }
    }
})

export const bulkTextureUploadActions = bulkTextureUpload.actions;
export const bulkTextureUploadSelector = state => state.bulkTextureUpload;
export const bulkTextureUploadReducer = bulkTextureUpload.reducer;
export default bulkTextureUploadReducer;

export const selectIsBulkTextureModalOpen = (state) => state.bulkTextureUpload.show;
export const selectIsBulkTextureModalHasData = (state) => state.bulkTextureUpload.hasData;
export const selectIsBulkTextureProcessing = (state) => state.bulkTextureUpload.processing;
export const selectIsBulkTextureModalExpand = (state) => state.bulkTextureUpload.expand;